import { styled } from "@mui/system";
// MATERIAL-UI
import { ListItem, ListItemText, Typography, Grid, Button, TextField } from "@mui/material";

export const GlobalSearchStyledContainer = styled(Grid)(({ theme }) => ({
  width: "100%",
  height: "100%",
}));

export const GlobalSearchStyledSearchBar = styled(TextField)(({ theme }) => ({
  width: "450px",
  [theme.breakpoints.down(1250)]: {
    width: "260px",
    maxWidth: "380px",
    textAlign: "end",
  },
  [`& fieldset`]: {
    borderRadius: "20px",
    border: `none`,
    background: "#BDC2C550",
  },
  "& .MuiOutlinedInput-input": {
    padding: 6,
    fontWeight: "bold",
  },
}));

export const GlobalSearchStyledSearchList = styled(Grid)(({ theme }) => ({
  maxHeight: "480px",
  overflowY: "auto",
  borderRadius: "0px 0px 8px 8px",
  height: "auto",
  backgroundColor: "#fff",
  justifyContent: "center",
  alignItems: "center",
  gap: "8px",
  position: "fixed",
  zIndex: "9999",
  width: "450px",
  padding: "4px 8px",
  marginTop: "17px",
  boxShadow: "0px 8px 16px 0px rgba(216, 216, 218, 0.90)",
  [theme.breakpoints.down(1250)]: {
    maxWidth: "280px",
  },
}));

export const GlobalSearchStyledError = styled("div")(({ theme }) => ({
  marginRight: "12px",
}));

export const GlobalSearchStyledListItem = styled(ListItem)(({ theme }) => ({
  width: "100%",
  padding: "4px 8px",
  cursor: "pointer",
  transition: "background-color 0.3s",
  "&:hover": {
    backgroundColor: theme.palette.primary.contrastText,
  },
}));

export const GlobalSearchStyledListItemRank = styled(Typography)`
  display: "flex";
  width: "24px";
  height: "17px";
  justifycontent: "center";
  alignitems: "center";
`;

export const GlobalSearchStyledListItemIcon = styled("div")(({ theme }) => ({
  minWidth: "fit-content",
  maxHeight: "30px",
}));

export const GlobalSearchStyledListItemText = styled(ListItemText)(({ theme }) => ({
  display: "flex inline",
  "& .MuiTypography-root": {
    fontSize: "14px !important",
    display: "inherit",
  },
  [theme.breakpoints.down(1250)]: {
    "& .MuiTypography-root": {
      fontSize: "12px !important",
    },
  },
}));

export const GlobalSearchStyledSeeMoreStyle = styled(Button)(({ theme }) => ({
  display: "block",
  margin: "0 auto",
  color: "#FC4C4C",
  textDecoration: "underline",
  fontSize: "14px !important",
  textTransform: "capitalize",
  "&:hover": {
    backgroundColor: "#fff",
  },
}));

export const GlobalSearchStyledListButton = styled(Button)(({ theme, disabled }) => ({
  display: "flex",
  marginLeft: "10px",
  backgroundColor: theme.palette.background.default,
  border: `1px solid ${theme.palette.primary.main}`,
  color: theme.palette.text.primary,
  height: "25px",
  width: "66px",
  borderRadius: "20px",
  padding: "0px 8px",
  minWidth: "10px",
  fontSize: "14px",
  fontFamily: "Roobert",
  fontStyle: "normal",
  fontWeight: 300,
  lineHeight: "16px",
  textTransform: "capitalize",
  justifyContent: "center",
  alignItems: "center",
  [theme.breakpoints.down(1250)]: {
    fontSize: "12px",
    fontFamily: "Söhne",
    fontWeight: 400,
    fontStyle: "normal",
    lineHeight: "14px",
    height: "22px",
    width: "58px",
  },
  "&:hover": {
    backgroundColor: theme.palette.mode === "light" ? "#e5e7e8" : "#727374",
  },
  "&:disabled": {
    backgroundColor: disabled ? "#f2f2f2" : "white",
    color: disabled ? "#9e9e9e" : "#002035",
    border: disabled ? "1px solid #9e9e9e" : "1px solid #002035",
    cursor: "not-allowed !important",
    pointerEvents: "auto",
  },
}));
